import { createAction } from '@reduxjs/toolkit';

const ACTION_PREFIX = 'billing';

export const connectingToStripe = createAction(`${ACTION_PREFIX}/CONNECTION_TO_STRIPE`);
export const connectingToStripeFailed = createAction(`${ACTION_PREFIX}/CONNECTION_TO_STRIPE_FAILED`);

export const setBillingEditMode = createAction(`${ACTION_PREFIX}/SET_BILLING_EDIT_MODE`);

export const billingInfoFetch = createAction(`${ACTION_PREFIX}/FETCH_BILLING_INFO`);
export const billingInfoFetchSucceeded = createAction(`${ACTION_PREFIX}/FETCH_BILLING_INFO_SUCCEEDED`);
export const billingInfoFetchFailed = createAction(`${ACTION_PREFIX}/FETCH_BILLING_INFO_FAILED`);

export const invoicesFetch = createAction(`${ACTION_PREFIX}/FETCH_INVOICES`);
export const invoicesFetchRequest = createAction(`${ACTION_PREFIX}/FETCH_INVOICES_REQUEST`);
export const invoicesFetchSucceeded = createAction(`${ACTION_PREFIX}/FETCH_INVOICES_SUCCEEDED`);
export const invoicesFetchFailed = createAction(`${ACTION_PREFIX}/FETCH_INVOICES_FAILED`);

export const addCreditCard = createAction(`${ACTION_PREFIX}/ADD_CREDIT_CARD`);
export const addCreditCardSucceeded = createAction(`${ACTION_PREFIX}/ADD_CREDIT_CARD_SUCCEEDED`);
export const addCreditCardFailed = createAction(`${ACTION_PREFIX}/ADD_CREDIT_CARD_FAILED`);

export const addCreditCardOnBoarding = createAction(`${ACTION_PREFIX}/ADD_CREDIT_CARD_ONBOARDING`);
export const addCreditCardOnBoardingSucceeded = createAction(`${ACTION_PREFIX}/ADD_CREDIT_CARD_ONBOARDING_SUCCEEDED`);
export const addCreditCardOnBoardingFailed = createAction(`${ACTION_PREFIX}/ADD_CREDIT_CARD_ONBOARDING_FAILED`);

export const toggleBillingEditMode = createAction(`${ACTION_PREFIX}/TOGGLE_BILLING_EDIT_MODE`);

export const setBillingPage = createAction(`${ACTION_PREFIX}/SET_BILLING_PAGE`);
export const billingPreviousPage = createAction(`${ACTION_PREFIX}/BILLING_NEXT_PAGE`);
export const billingNextPage = createAction(`${ACTION_PREFIX}/BILLING_PREVIOUS_PAGE`);

export const BillingActions = {
  connectingToStripe,
  connectingToStripeFailed,

  setBillingEditMode,

  billingInfoFetch,
  billingInfoFetchSucceeded,
  billingInfoFetchFailed,

  invoicesFetch,
  invoicesFetchRequest,
  invoicesFetchSucceeded,
  invoicesFetchFailed,

  addCreditCard,
  addCreditCardSucceeded,
  addCreditCardFailed,

  addCreditCardOnBoarding,
  addCreditCardOnBoardingSucceeded,
  addCreditCardOnBoardingFailed,

  toggleBillingEditMode,

  setBillingPage,
  billingPreviousPage,
  billingNextPage,
};
